import { render, staticRenderFns } from "./ReviewCurrentReviewsAndRatings.vue?vue&type=template&id=1713d592&scoped=true"
import script from "./ReviewCurrentReviewsAndRatings.vue?vue&type=script&lang=js"
export * from "./ReviewCurrentReviewsAndRatings.vue?vue&type=script&lang=js"
import style0 from "./ReviewCurrentReviewsAndRatings.vue?vue&type=style&index=0&id=1713d592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713d592",
  null
  
)

export default component.exports